var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlannedBeerBottle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "16px",
    viewBox: "0 0 7 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "23051BA7-2129-4759-BBCE-B512BE169872") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.32015586,0 L3.60292106,0 C3.88871631,5.85225667e-17 4.1305623,0.211144982 4.16912414,0.494326743 L4.21578209,0.836962936 C4.23388435,0.969898251 4.19214692,1.10402115 4.10180995,1.20321148 C4.01088706,1.30304516 3.96543848,1.43611529 3.97629486,1.57071052 L4.17652681,4.05314737 C4.22047801,4.59804578 4.44498348,5.11270184 4.81447964,5.51558963 C5.181178,5.91542679 5.38461538,6.43823375 5.38461538,6.9807625 L5.38461538,13.1428571 C5.38461538,13.6162441 5.00085946,14 4.52747253,14 L1.3956044,14 C0.922217467,14 0.538461538,13.6162441 0.538461538,13.1428571 L0.538461538,6.9807625 C0.538461538,6.43823375 0.74189892,5.91542679 1.10859729,5.51558963 C1.47809344,5.11270184 1.70259891,4.59804578 1.74655011,4.05314737 L1.94678207,1.57071052 C1.95763844,1.43611529 1.91218986,1.30304516 1.82126697,1.20321148 C1.73093,1.10402115 1.68919257,0.969898251 1.70729483,0.836962936 L1.75395279,0.494326743 C1.79251463,0.211144982 2.03436061,-5.85225667e-17 2.32015586,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: -0.75,
    y: -0.75,
    width: 6.34615385,
    height: 15.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.211538462,
    y: -0.75,
    width: 6.34615385,
    height: 15.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1",
    fill: "black"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Supply-Analytics-Overview---GMSupply",
    transform: "translate(-171.000000, -172.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layout",
    transform: "translate(154.000000, 84.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rows",
    transform: "translate(15.000000, 89.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "planned-beer-icon",
    transform: "translate(2.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.32015586,0 L3.60292106,0 C3.88871631,5.85225667e-17 4.1305623,0.211144982 4.16912414,0.494326743 L4.21578209,0.836962936 C4.23388435,0.969898251 4.19214692,1.10402115 4.10180995,1.20321148 C4.01088706,1.30304516 3.96543848,1.43611529 3.97629486,1.57071052 L4.17652681,4.05314737 C4.22047801,4.59804578 4.44498348,5.11270184 4.81447964,5.51558963 C5.181178,5.91542679 5.38461538,6.43823375 5.38461538,6.9807625 L5.38461538,13.1428571 C5.38461538,13.6162441 5.00085946,14 4.52747253,14 L1.3956044,14 C0.922217467,14 0.538461538,13.6162441 0.538461538,13.1428571 L0.538461538,6.9807625 C0.538461538,6.43823375 0.74189892,5.91542679 1.10859729,5.51558963 C1.47809344,5.11270184 1.70259891,4.59804578 1.74655011,4.05314737 L1.94678207,1.57071052 C1.95763844,1.43611529 1.91218986,1.30304516 1.82126697,1.20321148 C1.73093,1.10402115 1.68919257,0.969898251 1.70729483,0.836962936 L1.75395279,0.494326743 C1.79251463,0.211144982 2.03436061,-5.85225667e-17 2.32015586,0 Z",
    id: "beer"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.38461538,7.76743188 L5.38461538,13.1428571 C5.38461538,13.6162441 5.00085946,14 4.52747253,14 L1.3956044,14 C0.922217467,14 0.538461538,13.6162441 0.538461538,13.1428571 L0.538461538,7.26923077 L0.538461538,7.26923077 L2.07351972,7.98301488 C2.78399841,7.47764835 3.39182157,7.14997673 3.89698921,7 C4.33833119,6.86897215 4.77258066,6.98941495 5.19973762,7.36132839 C5.31718997,7.46359213 5.38461538,7.61169837 5.38461538,7.76743188 Z",
    id: "beer",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#404040",
    strokeWidth: 0.5,
    fillOpacity: 0.6,
    fill: "#FEF9E7",
    cx: 3.68071654,
    cy: 12.4362487,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#404040",
    strokeWidth: 0.5,
    cx: 2.1317176,
    cy: 11.3298209,
    r: 1
  }), /*#__PURE__*/React.createElement("use", {
    id: "outline",
    stroke: "#404040",
    mask: "url(#mask-2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: 2.08,
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.269230769,7.12995044 C1.27317854,7.12995044 2.05859824,8.61538462 3.52800849,8.61538462 C4.99741874,8.61538462 5.63470867,7.73495654 5.38592167,7.39869675 C5.13713468,7.06243696 4.27892375,6.45057197 1.88352876,8.06335525",
    id: "Path-12",
    stroke: "#404040",
    strokeWidth: 0.7
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlannedBeerBottle);
export default __webpack_public_path__ + "static/media/planned-beer-bottle.2834064e2398fcfcc112dff87b619de3.svg";
export { ForwardRef as ReactComponent };